import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import TeamMemberSendInviteModal from '../../components/team-members/TeamMemberSendInviteModal'
import { sendInvite } from '../../state/actions/team_members/index'
import { IMemberSearchObject, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps<any>) => {
  return {
    teamMember: state.teamMember.items[ownProps.match.params.id],
    onClose: ownProps.history.goBack
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSendInviteClick: (teamMember: IMemberSearchObject) => {
      return dispatch(sendInvite(teamMember))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberSendInviteModal)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberSendInviteModal.ts